const events = {
  analytics: {
    pageview: 'analytics:pageview',
    fire_page_view: 'analytics:fire_page_view',
  },
  collections: {
    search_collections: 'collections:search_collections',
    resource_added: 'collections:resource_added',
    add_clicked: 'collections:add_clicked',
    created: 'collections:created',
    login_popup: 'collections:login_popup',
    account_create: 'collections:account_create',
  },
  download_btn: {
    initial_click: 'download_btn:initial_click',
    match_eezycore_free_dupe: 'download_btn:match_eezycore_free_dupe',
  },
  editor: {
    command: 'commandexec',
    exit: 'editor:exit',
    load: 'editor:load',
  },
  errors: {
    error404_page: 'errors:error404_page',
  },
  locale_prompt: {
    locale_prompt_accepted: 'locale_prompt:locale_prompt_accepted',
    locale_prompt_connects: 'locale_prompt:locale_prompt_connects',
    locale_prompt_dismissed: 'locale_prompt:locale_prompt_dismissed',
    switch_language: 'locale_prompt:switch_language',
  },
  generic: {
    ez_toggle_change: 'generic:ez_toggle_change',
  },
  modal: {
    close_modal: 'modal:close_modal',
  },
  photos_banner: {
    photos_banner_dismissed: 'photos_banner:photos_banner_dismissed',
    photos_banner_learn_more: 'photos_banner:photos_banner_learn_more',
  },
  resources: {
    grid: {
      contributor_info_profile_click: 'resources:grid:contributor_info_profile_click',
    },
  },
  search: {
    apply_filters: 'search:apply_filters',
    click: 'search:click',
    filter: 'search:filter',
    hide_show_search_filters: 'search:hide_show_search_filters',
    search_type: 'search:search_type',
    without_results: 'search:without_results',
    trending_search_click: 'search:trending_search_click',
    header_search_filter: 'search:header_search_filter',
    sponsored_click: 'search:sponsored_click',
    update_content_type: 'search:update_content_type',
    reset_hidden_filters: 'search:reset_hidden_filters',
  },
  sessions: {
    new_account_created: 'sessions:new_account_created',
    user_signup_survey: 'sessions:user_signup_survey',
    social: {
      login_with_google: 'sessions:social:login_with_google',
      login_with_facebook: 'sessions:social:login_with_facebook',
      create_account_with_google: 'sessions:social:create_account_with_google',
      create_account_with_facebook: 'sessions:social:create_account_with_facebook',
    },
  },
  show_page: {
    attribution_link_copied: 'show_page:attribution_link_copied',
    attribution_join_pro_click: 'show_page:attribution_join_pro_click',
    download_ad_modal: 'show_page:download_ad_modal',
    download_limit_modal_connects: 'show_page:download_limit_modal_connects',
    download_ad_modal_connects: 'show_page:download_ad_modal_connects',
    favorite: 'show_page:favorite',
    editor_button_click: 'show_page:editor_button_click',
    license_selector_free_modal_connects: 'show_page:license_selector_free_modal_connects',
    license_selector_free_modal_closes: 'show_page:license_selector_free_modal_closes',
    license_selector_free_modal_free_button: 'show_page:license_selector_free_modal_free_button',
    license_selector_free_modal_pro_button: 'show_page:license_selector_free_modal_pro_button',
    license_selector_free_modal_learn_more: 'show_page:license_selector_free_modal_learn_more',
    // start split-test: resource_show_modal_view
    modal: {
      build_resource_navigation_context: 'show_page:modal:build_resource_navigation_context',
      close_click: 'show_page:close_click',
      history_close_modal_view: 'show_page:modal:history_close_modal_view',
      next_arrow_click: 'show_page:modal:next_arrow_click',
      prev_arrow_click: 'show_page:modal:prev_arrow_click',
      reload_modal_view: 'show_page:modal:reload_modal_view',
      update_resource_navigation_context: 'show_page:modal:update_resource_navigation_context',
    },
    // end split-test: resource_show_modal_view
    more_info: 'show_page:more_info',
    reveal_free_attribution_slidedown: 'show_page:reveal_free_attribution_slidedown',
    related_resource_click: 'show_page:related_resoure_click',
    share: 'show_page:share',
    share_facebook: 'show_page:share_facebook',
    share_html: 'show_page:share_html',
    share_pinterest: 'show_page:share_pinterest',
    share_twitter: 'show_page:share_twitter',
    zoom_in: 'show_page:zoom_in',
  },
  site_header: {
    explore_brusheezy: 'site_header:explore_brusheezy',
    explore_cats: 'site_header:explore_cats',
    explore_nav: 'site_header:explore_nav',
    explore_newest: 'site_header:explore_newest',
    explore_videezy: 'site_header:explore_videezy',
    header_join_pro: 'site_header:header_join_pro',
    header_login: 'site_header:header_login',
    header_signup: 'site_header:header_signup',
    related_tag_click: 'site_header:related_tag_click',
  },
  sponsored_search: {
    without_results: 'sponsored_search:without_results',
  },
  ten_download_limit: {
    join_pro: 'ten_download_limit:join_pro',
    open: 'ten_download_limit:open',
  },
  three_download_limit: {
    control_login_click: 'three_download_limit:control_login_click',
    control_facebook_join: 'three_download_limit:control_facebook_join',
    control_google_join: 'three_download_limit:control_google_join',
    control_pop: 'three_download_limit:control_pop',
    control_step_one_click: 'three_download_limit:control_step_one_click',
    control_step_two_click: 'three_download_limit:control_step_two_click',
    facebook_join: 'three_download_limit:facebook_join',
    google_join: 'three_download_limit:google_join',
    login_click: 'three_download_limit:login_click',
    open: 'three_download_limit:open',
    step_one_click: 'three_download_limit:continue_click',
    step_two_click: 'three_download_limit:signup_click',
    unconfirmed_open: 'three_download_limit:unconfirmed_open',
    unconfirmed_send: 'three_download_limit:unconfirmed_send',
  },
  checkout: {
    purchase: 'checkout:purchase',
    error: 'checkout:error',
  },
  partner: {
    coupon_click: 'partner:coupon_click',
    pagination_popup: 'partner:pagination_popup',
    results_click: 'partner:results_click',
    infinite_scroll_click: 'partner:infinite_scroll_click',
    search_popup: 'partner:search_popup',
  },
  vertical_grid: {
    show_more_click: 'vertical_grid:show_more_click',
    more_results_loaded: 'vertical_grid:more_results_loaded',
    end_of_results: 'vertical_grid:end_of_results',
  },
  util: {
    ez_drop_down: {
      close_drop_down: 'util:ez_drop_down:close_drop_down',
    },
  },
};

export default events;
